import React from "react";
import { useTranslation } from "react-i18next";
import { AppLayout } from "../../../layouts";
import { Header, Sides } from "../../../components";
import { Col, Container, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { actionDoctor } from "../../../redux/actions";
import { ChatWindows } from "../../../commonPage";

const ChatWithDoctor = ({ loginData }) => {
    const { t } = useTranslation();


    const location = useLocation();
    const chat = location.state?.chat;

    // useEffect(() => {
    //     if (loginData?.userGuid) {
    //         setCredentials((prev) => ({
    //             ...prev,
    //             PatientGuid: loginData.userGuid,
    //             Currency: loginData.currencyCode || "EUR",
    //             RequestTimeZone: loginData.timeZoneId,
    //             LanguageId: loginData.languageId,
    //         }));
    //     }
    // }, [loginData]);

    // useEffect(() => {
    //     if (chat?.doctorGuid) {
    //         setCredentials((prev) => ({
    //             ...prev,
    //             DoctorGuid: chat?.doctorGuid,
    //             appointmentGuid: chat?.appointmentGuid,
    //         }));
    //     }
    // }, [chat]);

    const rightSide = (
        <Container
            fluid
            className={`exado-container1 doctor-chats doctor-chat-with-patient`}
        >
            <Row className="exado-row1">
                <Col>
                    <Header.HeadingPage
                        pageHeading={`${t("chat_room_with")} ${chat?.doctorName}`}
                    />
                </Col>
            </Row>
            <Row className="exado-row1">
                <Col className="d-flex justify-content-between align-items-center">
                    <h3 className="flex-grow-1 exado-title-three cwp-name">
                        {chat?.doctorName}
                    </h3>
                    {/* <Buttton.Buttton
                        children={t("diagnosis_reports")}
                        // onClick={() => handleSubmit(credentials)}
                        className="btn-border-Aqua_Teal"
                    /> */}
                    {/* <Buttton.Buttton
                        children={t("view_profile")}
                        // onClick={() => handleSubmit(credentials)}
                        className="btn-solid-Aqua_Teal"
                    /> */}
                </Col>
            </Row>
            {/* <Row className="exado-row1">
                <Col md={4}>
                    <Cards.Cardd
                        header={
                            <>
                                <div className="blkIcon">
                                    <PiCalendar className="header-Icn" />
                                </div>
                                <h5 className="exado-title-seven card-header-text">
                                    {t("appointment")} {t("Information")}
                                </h5>
                            </>
                        }
                        content={
                            <ListGroup className="card-content-list">
                                <ListGroup.Item>
                                    <label className="card-list-lable">{t("date")} :</label>
                                    <p className="exado-title-six">
                                        {new Date(chatAppointmentDetails[0]?.appointmentDate)
                                            .toLocaleDateString("en-US", {
                                                month: "short",
                                                day: "numeric",
                                                year: "numeric",
                                            })
                                            .replace(",", "th,")}
                                    </p>
                                </ListGroup.Item>
                                <ListGroup.Item>
                                    <label className="card-list-lable">{t("time")} :</label>
                                    <p className="card-list-content exado-title-six">
                                        {new Date(
                                            chatAppointmentDetails[0]?.appointmentDate
                                        ).toLocaleTimeString("en-US", {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            hour12: true,
                                        })}
                                    </p>
                                </ListGroup.Item>
                                <ListGroup.Item>
                                    <label className="card-list-lable">
                                        {t("booking_id")} :{" "}
                                    </label>
                                    <p className="card-list-content exado-title-six">
                                        {chatAppointmentDetails[0]?.chatBookingId}
                                    </p>
                                </ListGroup.Item>
                                <ListGroup.Item>
                                    <label className="card-list-lable">
                                        {t("consultation_fee")} :{" "}
                                    </label>
                                    <p className="card-list-content exado-title-six">
                                        {chatAppointmentDetails[0]?.chatFees +
                                            " " +
                                            chatAppointmentDetails[0]?.appointmentCurrency}
                                    </p>
                                </ListGroup.Item>
                            </ListGroup>
                        }
                        className="cardd cwp-card"
                    />
                </Col>
                <Col md={8}>
                    <Cards.Cardd
                        header={
                            <>
                                <div className="blkIcon">
                                    <PiCalendar className="header-Icn" />
                                </div>
                                <h5 className="exado-title-seven card-header-text">
                                    {t("appointment")} {t("details")}
                                </h5>
                            </>
                        }
                        content={
                            <ul className="pd-ul">
                                <li className="pd-li exado_body_text_three">
                                    Q: {t("patient_Details.since_when_symptoms_are_active")}
                                </li>
                                <li className="pd-li exado_body_text_three pd-li-ans">
                                    A: {chatAppointmentDetails[0]?.sinceWhen}
                                </li>
                                <li className="pd-li exado_body_text_three">
                                    Q: {t("patient_Details.is_any_medication_or_treatment_taken")}
                                </li>
                                <li className="pd-li exado_body_text_three pd-li-ans">
                                    A: {chatAppointmentDetails[0]?.anyMedication}
                                </li>
                                <li className="pd-li exado_body_text_three">
                                    Q: {t("patient_Details.has_diagnosis_been_given")}
                                </li>
                                <li className="pd-li exado_body_text_three pd-li-ans">
                                    A: {chatAppointmentDetails[0]?.diagnosisGiven}
                                </li>
                                <li className="pd-li exado_body_text_three">
                                    Q: {t("patient_Details.describe_problem_or_symptoms")}
                                </li>
                                <li className="pd-li exado_body_text_three pd-li-ans">
                                    A: {chatAppointmentDetails[0]?.symptoms}
                                </li>
                            </ul>
                        }
                        footer={
                            <Buttton.Buttton
                                className="btn-solid-Aqua_Teal"
                                children={t("consult")}
                            // onClick={() => setShowModal(true)}
                            />
                        }
                        className="cardd cwp-card"
                    />
                </Col>
            </Row> */}
            <Row className="exado-row1">
                <Col md={12}>
                    <ChatWindows
                        chat={chat}
                        loginData={loginData}
                        userType={2}
                        displayName={chat?.doctorName}
                        fetchChatHistoryAction={actionDoctor.postGetChatHistory}
                    />
                </Col>
            </Row>
        </Container>
    );
    return (
        <AppLayout.AppLayoutOne
            leftSide={<Sides.LeftSides loginData={loginData} />}
            rightSide={rightSide}
        />
    );
};

export default ChatWithDoctor;
